import * as types from '../actions/action-types';
const { Map, List } = require('immutable');

const defaultAlbumArt = 'https://albumart.customchannels.rocks/default-album-art.png';

const initialState = {
    player: Map({
      title: 'Player Name',
      stream_url: null,
      nowplaying_url: null,
      remix: null,
    }),
    currentTrack: Map({
      album: 'Album Name',
      artist: null,
      album_art: {
        large: defaultAlbumArt,
        small: defaultAlbumArt
      },
      played_at: null,
      sample_url: null,
      title: null,
      stream_url: null
    }),
    history: List()
};

export default (state = initialState, action) => {
    switch(action.type) {
        case types.UPDATE_PLAYER_DATA:
            return {
                ...state, 
                player: state.player.merge(action.data)
            };
        case types.UPDATE_CURRENT_STREAM_URL:
            return {
                ...state, 
                currentTrack: state.currentTrack.set('stream_url', action.data)
            };
        case types.UPDATE_CURRENT_TRACK:
            return {
                ...state, 
                currentTrack: state.currentTrack.merge(action.data)
            };
        case types.UPDATE_HISTORY:
          return {
            ...state,
            history: state.history.merge(action.data)
          }
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/app-reducer.js